<template>
  <div class="lq-progress" v-if="isShow">
    <div
      class="lq-progress-mask"
      :style="{'background': maskBackground}"
      @click.stop
      v-if="!isNoMask"
    ></div>
    <div
      class="lq-progress-content"
      :class="{'is-line': type=='line', 'is-circle': type=='circle'}"
    >
      <el-progress type="line" :percentage="percentage" v-if="type=='line'"></el-progress>
      <el-progress type="circle" :percentage="percentage" :width="100" v-if="type=='circle'"></el-progress>
      <!-- <el-progress type="dashboard" :percentage="percentage" :color="colors" :width="80"></el-progress> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      isNoMask: false,

      maskBackground: '',
      percentage: 0,
      type: ''
    };
  },
  mounted() { },
  methods: {
    update(percentage) {
      if (percentage >= 100) {
        this.percentage = 100;
      } else {
        this.percentage = percentage;
      }
    },
    close() {
      this.isShow = false;
      this.$nextTick(() => {
        this.$destroy(); // 销毁
      })
    }
  }
}
</script>

<style lang="scss">
.lq-progress {
  z-index: 91000-1;
  .lq-progress-mask {
    position: fixed;
    z-index: 91000-1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
  }
  .lq-progress-content {
    &.is-line {
      position: absolute;
      left: 50%;
      bottom: -6px;
      transform: translateX(-35%);
      width: 100px;
      .el-progress__text {
        font-size: 12px !important;
      }
    }
    &.is-circle {
      position: fixed;
      z-index: 91000-1;
      top: 40%;
      left: 50%;
      margin-left: -57px;
    }
  }
}
</style>